import { render, staticRenderFns } from "./StorageBaseMinio_.vue?vue&type=template&id=03a634bc&"
import script from "./StorageBaseMinio_.vue?vue&type=script&lang=js&"
export * from "./StorageBaseMinio_.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports